<div class="flex flex-col lg:flex-row h-screen overflow-hidden">
  <div class="lg:w-3/5 w-full relative overflow-hidden bg-gradient-to-br from-emerald-600 via-teal-600 to-green-700">
    <div class="absolute inset-0">
      <div class="absolute inset-0 bg-gradient-to-br from-transparent via-white/5 to-transparent"></div>
    </div>

    <video autoplay muted loop playsinline preload="auto" poster="assets/images/energy-background.jpg"
      class="absolute inset-0 w-full h-full object-cover z-0 hidden lg:block opacity-40">
      <source src="assets/videos/login-bg.mp4" type="video/mp4" />
      <img src="assets/images/energy-background.jpg" alt="Login background"
        class="absolute inset-0 w-full h-full object-cover z-0" />
    </video>
    <img src="assets/images/energy-background.jpg" alt="Login background"
      class="absolute inset-0 w-full h-full object-cover z-0 lg:hidden opacity-40" />
    <div class="absolute top-6 left-6 z-20">
      <div
        class="w-16 h-16 bg-white/20 backdrop-blur-md rounded-2xl border border-white/30 flex items-center justify-center shadow-2xl">
        <img class="w-10 h-10 rounded-xl" src="assets/icon/app-icon.svg" alt="App Icon" />
      </div>
    </div>
    <div class="relative z-10 items-center justify-center h-full p-8 hidden lg:flex">
      <div class="text-center text-white max-w-lg">
        <div class="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8 shadow-2xl ">
          <h1
            class="p-2 text-4xl lg:text-5xl font-bold mb-4 bg-gradient-to-r from-white to-green-100 bg-clip-text text-transparent">
            {{environment.branding.name}}
          </h1>
          <p class="text-lg lg:text-xl mb-6 text-white/90">
            Nachhaltige Lösungen für Ihr Unternehmen
          </p>
        </div>
      </div>
    </div>
  </div>
  <div
    class="lg:w-2/5 w-full bg-white/95 dark:bg-gray-800/95 backdrop-blur-xl flex flex-col justify-center p-8 lg:p-12 relative h-full">
    <div class="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-emerald-500/10 to-teal-500/10 rounded-bl-full">
    </div>
    <div
      class="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-teal-500/10 to-emerald-500/10 rounded-tr-full">
    </div>

    <div class="relative z-10 w-full max-w-md mx-auto">
      <div class="text-center mb-8">
        <h2 class="text-3xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent mb-2">
          Willkommen zurück
        </h2>
        <p class="text-gray-600 dark:text-gray-300">Melde dich an, um fortzufahren</p>
      </div>


      <div
        class="bg-white/60 dark:bg-gray-800/60 backdrop-blur-xl rounded-2xl p-6 border border-gray-200/50 dark:border-gray-700/50 shadow-xl">
        <form [formGroup]="loginForm" class="space-y-6">
          <div class="space-y-2">
            <label for="email_field" class="block text-sm font-semibold text-gray-700 dark:text-gray-200">
              E-Mail Adresse
            </label>
            <input pInputText id="email_field" [pAutoFocus]="true" type="email" placeholder="deine@email.de"
              class="w-full p-3 border-2 border-gray-200 dark:border-gray-600 rounded-xl bg-white/80 dark:bg-gray-700/80 backdrop-blur-sm focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 transition-all duration-300"
              formControlName="email" />
          </div>


          <div class="space-y-2">
            <label for="password_field" class="block text-sm font-semibold text-gray-700 dark:text-gray-200">
              Passwort
            </label>
            <p-password id="password_field" (keyup.enter)="performStandardLogin()" formControlName="password"
              placeholder="Dein Passwort" [toggleMask]="true" styleClass="w-full" [fluid]="true" [feedback]="false"
              class="w-full">
            </p-password>
          </div>

          <!-- Form Options -->
          <div class="flex justify-end pb-2">
            <button type="button"
              class="text-sm font-medium text-emerald-600 hover:text-emerald-700 dark:text-emerald-400 dark:hover:text-emerald-300 transition-colors cursor-pointer"
              (click)="isPasswordResetRequestVisible = true">
              Passwort vergessen?
            </button>
          </div>

          <!-- Login Button -->
          <p-button label="Anmelden" (click)="performStandardLogin()" outlined="true" [disabled]="isLoginInitiated"
            [loading]="isLoginInitiated" styleClass="w-full">
          </p-button>
        </form>
      </div>

      <!-- Additional Features -->
      <div class="mt-8 grid grid-cols-3 gap-4 text-center">
        <div
          class="bg-white/40 dark:bg-gray-800/40 backdrop-blur-md rounded-xl p-4 border border-gray-200/50 dark:border-gray-700/50">
          <i class="pi pi-shield text-2xl text-emerald-600 mb-2"></i>
          <p class="text-xs text-gray-600 dark:text-gray-300">Sicher</p>
        </div>
        <div
          class="bg-white/40 dark:bg-gray-800/40 backdrop-blur-md rounded-xl p-4 border border-gray-200/50 dark:border-gray-700/50">
          <i class="pi pi-heart-fill text-2xl text-green-500 mb-2"></i>
          <p class="text-xs text-gray-600 dark:text-gray-300">Nachhaltig</p>
        </div>
        <div
          class="bg-white/40 dark:bg-gray-800/40 backdrop-blur-md rounded-xl p-4 border border-gray-200/50 dark:border-gray-700/50">
          <i class="pi pi-star text-2xl text-yellow-500 mb-2"></i>
          <p class="text-xs text-gray-600 dark:text-gray-300">Smart</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Password Reset Drawer -->
<p-drawer [(visible)]="isPasswordResetRequestVisible" position="right" styleClass="!w-full md:!w-96 lg:!w-[28rem]">

  <div
    class="bg-gradient-to-br from-emerald-50 to-teal-50 dark:from-gray-800 dark:to-gray-900 rounded-2xl p-6 border border-gray-200 dark:border-gray-700">
    <div class="text-center mb-6">
      <div
        class="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
        <i class="pi pi-key text-2xl text-white"></i>
      </div>
      <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-2">Passwort vergessen?</h3>
      <p class="text-sm text-gray-600 dark:text-gray-300">Gib deine E-Mail ein und wir senden dir einen Reset-Link</p>
    </div>

    <form [formGroup]="passwordResetRequestForm" class="space-y-6">
      <div class="space-y-2">
        <label for="reset_email_field" class="block text-sm font-semibold text-gray-700 dark:text-gray-200">
          E-Mail Adresse
        </label>
        <input pInputText id="reset_email_field" [pAutoFocus]="true" type="email" placeholder="deine@email.de"
          class="w-full p-3 border-2 border-gray-200 dark:border-gray-600 rounded-xl bg-white/80 dark:bg-gray-700/80 backdrop-blur-sm focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 transition-all duration-300"
          formControlName="email" />
      </div>

      <p-button label="Reset-Link senden" (click)="performPasswordResetRequest()"
        [disabled]="isPasswordResetRequestInitiated" [loading]="isPasswordResetRequestInitiated"
        styleClass="w-full mt-4" />
    </form>
  </div>
</p-drawer>

<!-- Password Reset Form Drawer -->
<p-drawer [(visible)]="isPasswordResetVisible" header="Neues Passwort setzen" position="right"
  styleClass="!w-full md:!w-96 lg:!w-[28rem]" [closable]="false">

  <div
    class="bg-gradient-to-br from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-900 rounded-2xl p-6 border border-gray-200 dark:border-gray-700">
    <div class="text-center mb-6">
      <div
        class="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4">
        <i class="pi pi-lock text-2xl text-white"></i>
      </div>
      <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-2">Neues Passwort</h3>
      <p class="text-sm text-gray-600 dark:text-gray-300">Wähle ein sicheres Passwort für dein Konto</p>
    </div>

    <form [formGroup]="passwordResetForm" class="space-y-6">
      <div class="space-y-2">
        <label for="password_reset_field" class="block text-sm font-semibold text-gray-700 dark:text-gray-200">
          Neues Passwort
        </label>
        <p-password formControlName="password" placeholder="Neues Passwort" [toggleMask]="true" [fluid]="true"
          autocomplete="off" id="password_reset_field" promptLabel="Wähle ein Passwort" weakLabel="Zu schwach"
          mediumLabel="Mittlere Stärke" strongLabel="Starkes Passwort" styleClass="w-full">

          <ng-template #header>
            <div class="font-semibold text-sm mb-4 text-gray-700 dark:text-gray-200">Passwort-Richtlinien</div>
          </ng-template>

          <ng-template #footer>
            <p-divider />
            <ul class="space-y-2 text-sm mt-4">
              <li class="flex items-center gap-2">
                <i class="pi text-xs" [ngClass]="{
                  'pi-check text-green-600': hasUppercase(passwordResetForm.get('password')?.value),
                  'pi-times text-red-500': !hasUppercase(passwordResetForm.get('password')?.value)
                }"></i>
                <span class="text-gray-600 dark:text-gray-300">Mindestens ein Großbuchstabe</span>
              </li>
              <li class="flex items-center gap-2">
                <i class="pi text-xs" [ngClass]="{
                  'pi-check text-green-600': hasLowercase(passwordResetForm.get('password')?.value),
                  'pi-times text-red-500': !hasLowercase(passwordResetForm.get('password')?.value)
                }"></i>
                <span class="text-gray-600 dark:text-gray-300">Mindestens eine Zahl</span>
              </li>
              <li class="flex items-center gap-2">
                <i class="pi text-xs" [ngClass]="{
                  'pi-check text-green-600': hasMinLength(passwordResetForm.get('password')?.value, 8),
                  'pi-times text-red-500': !hasMinLength(passwordResetForm.get('password')?.value, 8)
                }"></i>
                <span class="text-gray-600 dark:text-gray-300">Mindestens 8 Zeichen</span>
              </li>
            </ul>
          </ng-template>
        </p-password>
      </div>

      <div class="space-y-2">
        <label for="password_reset_field_confirm" class="block text-sm font-semibold text-gray-700 dark:text-gray-200">
          Passwort bestätigen
        </label>
        <p-password formControlName="passwordConfirm" id="password_reset_field_confirm"
          placeholder="Passwort wiederholen" [toggleMask]="true" (keyup.enter)="performPasswordReset()"
          [feedback]="false" [fluid]="true" autocomplete="off" styleClass="w-full">
        </p-password>
      </div>

      <p-button label="Passwort ändern" (click)="performPasswordReset()" [fluid]="true"
        [disabled]="isPasswordResetInitiated || passwordResetForm.invalid" [loading]="isPasswordResetInitiated"
        styleClass="w-full p-3 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300" />
    </form>
  </div>
</p-drawer>